<template>
    <div style="padding: 10px 0 30px 0;margin: 0 10px;">
      <div style="max-height: 450px;overflow-y: auto">
        <el-form style="margin: 0 30px 0 0px;" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="125px" class="demo-ruleForm">
          <el-form-item label="服务内容" prop="st_id">
            <el-cascader v-fixZoom :disabled="noService" style="width: 100%" :options="typeTree" v-model="addEditForm.st_id" :filterable="true" placeholder="请选择服务类型及内容"
                         :props="{ checkStrictly: true, value: 'id', label: 'typename', children: 'child', emitPath: false, disabled: 'isService'}" ref="typeOptions" @change="changeServiceType">
              <template #default="{data}">
                <span v-if="data.is_service !== 1 || data.isService" style="font-style: italic;color: #999999">{{ data.typename}}</span>
                <strong v-else style="color: #1a1a1a;">{{ data.typename}}</strong>
              </template>
            </el-cascader>
          </el-form-item>
          <el-form-item v-if="!isService" label="服务商" prop="so_id">
            <el-select v-fixZoom :disabled="!isAdd" v-model="addEditForm.so_id" placeholder="请选择服务商" style="width: 100%" @change="changeService">
              <el-option v-for="item in soOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务时长(分钟)" prop="">
            <el-input type="number" v-model="addEditForm.time_duration" placeholder="请输入服务时长（分钟）"></el-input>
          </el-form-item>
          <el-form-item label="服务价格(元)" prop="">
            <el-input type="number" v-model="addEditForm.price" placeholder="请输入服务价格（元）"></el-input>
          </el-form-item>
          <!--    隐藏拓展字段      -->
          <el-form-item v-if="false" label="发起服务扩展字段" prop="">
            <div style="display: flex">
              <div class="btn-add" @click="addService()">+ 添加</div>
              <div style="flex: 1;text-align: right;color: #AFB0B0;font-size: 12px">*此处可设置发起服务需要提供的额外信息</div>
            </div>
            <table class="table-type" v-if="serviceArr.length > 0">
              <tr><th>名称</th><th style="width: 140px;text-align: center">是否必填</th><th style="width: 70px;text-align: center">操作</th></tr>
              <tr v-for="(item, index) in serviceArr" :key="index">
                <td><input class="input" style="width: 100%;" type="text" placeholder="请输入" @blur="blurService(item)" v-model="item.key"/></td>
                <td><el-radio-group v-model="item.required"><el-radio :label="1">是</el-radio><el-radio :label="0">否</el-radio></el-radio-group></td>
                <td style="text-align: center"><i title="移除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delService(index)"></i></td>
              </tr>
            </table>
          </el-form-item>
          <el-form-item v-if="false" label="确认服务扩展字段" prop="">
            <div style="display: flex">
              <div class="btn-add" @click="addSure()">+ 添加</div>
              <div style="flex: 1;text-align: right;color: #AFB0B0;font-size: 12px">*此处可设置服务完成后需要填写的额外信息</div>
            </div>
            <table class="table-type" v-if="sureArr.length > 0">
              <tr><th>名称</th><th style="width: 140px;text-align: center">是否必填</th><th style="width: 70px;text-align: center">操作</th></tr>
              <tr v-for="(item, index) in sureArr" :key="index">
                <td><input class="input" style="width: 100%;" type="text" placeholder="请输入" @blur="blurSure(item)" v-model="item.key"/></td>
                <td><el-radio-group v-model="item.required"><el-radio :label="1">是</el-radio><el-radio :label="0">否</el-radio></el-radio-group></td>
                <td style="text-align: center"><i title="移除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delSure(index)"></i></td>
              </tr>
            </table>
          </el-form-item>
          <el-form-item v-if="false" label="确认服务照片类型" prop="">
            <div style="display: flex">
              <div class="btn-add" @click="addPicture">+ 添加</div>
              <div style="flex: 1;text-align: right;color: #AFB0B0;font-size: 12px">*此处可设置服务完成后需要上传的照片</div>
            </div>
            <table class="table-type" v-if="pictureArr.length > 0">
              <tr><th>名称</th><th style="width: 140px;text-align: center">是否必填</th><th style="width: 70px;text-align: center">操作</th></tr>
              <tr v-for="(item, index) in pictureArr" :key="index">
                <td><input class="input" style="width: 100%;" type="text" placeholder="请输入" @blur="blurPicture(item)" v-model="item.key"/></td>
                <td><el-radio-group v-model="item.required"><el-radio :label="1">是</el-radio><el-radio :label="0">否</el-radio></el-radio-group></td>
                <td style="text-align: center"><i title="移除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delPicture(index)"></i></td>
              </tr>
            </table>
          </el-form-item>
        </el-form>
      </div>
      <div style="margin-top: 30px">
        <el-row style="margin: 0 30px">
          <el-col :span="12">
            <div class="cancel-btn" @click="closeAdd()">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAddEdit('addEditForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
</template>

<script>
import {addsupplierservice} from '../../../api/serviceMark'
export default {
  name: 'addEditScontent',
  model: {
    prop: 'addEditContentShow',
    event: 'change'
  },
  props: {
    addEdit: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isAdd: true,
      soOptions: [],
      typeTree: [],
      allSupplier: [],
      treeData: [],
      addEditForm: {
        id: '',
        so_id: '',
        st_id: '',
        'service_name': '',
        'orgid': '',
        'time_duration': '', // 分
        'price': '', // 分
        is_have_type: 0,
        up_level: '',
        up_id: '',
        is_service: 0
      },
      addEditRules: {
        service_name: [
          { required: true, message: '请输入服务类型及内容', trigger: 'blur' }
        ],
        so_id: [
          { required: true, message: '请选择服务商', trigger: 'change' }
        ],
        st_id: [
          { required: true, message: '请选择服务类型', trigger: 'change' }
        ],
        orgid: [
          { required: true, message: '请选择所属组织', trigger: 'change' }
        ],
        time_duration: [
          { required: true, message: '请输入服务时长', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入服务价格', trigger: 'blur' }
        ]
      },
      isService: false,
      noService: true,
      // 发起拓展字段
      serviceArr: [],
      // 确认拓展字段
      sureArr: [],
      pictureArr: []
    }
  },
  created () {
    this.getTypeTree()
    this.getData()
  },
  methods: {
    getData () {
      console.log(123, this.addEdit)
      this.isAdd = this.addEdit.isAdd
      this.soOptions = this.addEdit.allSupplier
      this.allSupplier = this.addEdit.allSupplier
      if (this.isAdd) {
        this.addEditForm.id = 0
        if (this.addEdit.supplierId !== '') {
          this.addEditForm.so_id = this.addEdit.supplierId
          this.addEditForm.orgid = this.addEdit.orgid
        }
        if (this.addEdit.serviceRow !== '') {
          // 确定服务内容(服务类型)
          this.noService = true
          this.addEditForm.st_id = this.addEdit.serviceRow.id
          this.addEditForm.up_level = this.addEdit.serviceRow.level
          this.addEditForm.up_id = this.addEdit.serviceRow.id
          this.addEditForm.is_service = this.addEdit.serviceRow.is_service
          this.addEditForm.service_name = this.addEdit.serviceRow.typename
        } else {
          this.noService = false
        }
        this.isService = this.addEdit.isService
        // console.log(234, this.noService)
      } else {
        console.log(234, this.addEdit.row.picturerequirements)
        if (this.addEdit.row.service_requirements_tag === 1) {
          if (Array.isArray(this.addEdit.row.servicerequirements[0])) {
            this.serviceArr = this.addEdit.row.servicerequirements[0]
          }
          if (Array.isArray(this.addEdit.row.servicerequirements[1])) {
            this.sureArr = this.addEdit.row.servicerequirements[1]
          }
        }
        if (this.addEdit.row.picture_requirements_tag === 1) {
          if (Array.isArray(this.addEdit.row.picturerequirements)) {
            this.pictureArr = this.addEdit.row.picturerequirements
          }
        }
        this.noService = true
        let price = this.addEdit.row.price === '' ? '' : parseFloat(this.addEdit.row.price) / 100
        this.addEditForm = {
          'id': this.addEdit.row.id,
          'so_id': this.addEdit.row.so_id,
          'st_id': this.addEdit.row.st_id,
          'service_name': this.addEdit.row.service_name,
          'orgid': this.addEdit.row.orgid,
          'time_duration': this.addEdit.row.time_duration,
          'price': price,
          is_have_type: this.addEdit.row.is_have_type,
          up_level: this.addEdit.row.up_level,
          up_id: this.addEdit.row.up_id
        }
      }
    },
    getTypeTree () {
      let have = []
      if (this.addEdit.childData) {
        this.addEdit.childData.forEach(item => {
          have.push(item.st_id)
        })
      }
      // console.log('have', this.addEdit.childData, have)
      let lastLevel = 100
      const arr = this.clone(this.addEdit.types)
      for (let i = 0; i < arr.length; i++) {
        arr[i].isService = false
        if (arr[i].is_service === 0) {
          arr[i].isService = true
        } else {
          // console.log(arr[i].id)
          if (have.indexOf(arr[i].id) > -1) {
            arr[i].isService = true
            // console.log(999, arr[i])
          }
        }
        if (arr[i].level < lastLevel) {
          lastLevel = arr[i].level
        }
      }
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].level === lastLevel) {
          this.typeTree.push(arr[i])
        }
      }
      for (let i = 0; i < this.typeTree.length; i++) {
        const child = this.arrayToNode1(arr, this.typeTree[i].id)
        if (child.length !== 0) {
          this.typeTree[i].child = child
        }
      }
      console.log(this.typeTree)
    },
    // 递归
    arrayToNode1 (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.upid === pid) {
          const arrayToNode = vm.arrayToNode1(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    changeService (id) {
      for (let i = 0; i < this.soOptions.length; i++) {
        if (id === this.soOptions[i].id) {
          this.addEditForm.orgid = this.soOptions[i].orgid
        }
      }
    },
    changeServiceType () {
      let node = this.$refs.typeOptions.getCheckedNodes()
      this.addEditForm.up_level = node[0].data.level
      this.addEditForm.up_id = node[0].data.id
      this.addEditForm.is_service = node[0].data.is_service
      this.addEditForm.service_name = node[0].data.typename
    },
    // 发起
    addService () {
      let obj = {key: '', value: '', required: 0}
      this.serviceArr.push(obj)
    },
    blurService (item) {
      let flag = 0
      this.serviceArr.forEach(val => {
        if (val.key === item.key) {
          flag += 1
        }
      })
      if (flag > 1) {
        this.$message({ message: '已有字段，请检查', type: 'warning' })
      }
    },
    delService (index) {
      this.serviceArr.splice(index, 1)
    },
    // 确认
    addSure () {
      let obj = {key: '', value: '', required: 0}
      this.sureArr.push(obj)
    },
    blurSure (item) {
      let flag = 0
      this.sureArr.forEach(val => {
        if (val.key === item.key) {
          flag += 1
        }
      })
      if (flag > 1) {
        this.$message({ message: '已有字段，请检查', type: 'warning' })
      }
    },
    delSure (index) {
      this.sureArr.splice(index, 1)
    },
    addPicture () {
      let obj = {key: '', value: '', required: 0}
      this.pictureArr.push(obj)
    },
    blurPicture (item) {
      let flag = 0
      this.pictureArr.forEach(val => {
        if (val.key === item.key) {
          flag += 1
        }
      })
      if (flag > 1) {
        this.$message({ message: '已有字段，请检查', type: 'warning' })
      }
    },
    delPicture (index) {
      this.pictureArr.splice(index, 1)
    },
    closeAdd () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let price = this.addEditForm.price === '' ? '' : parseFloat(this.addEditForm.price) * 100
          let servicerequirementstag = 0
          let servicerequirements = []
          let arr0 = []
          let arr1 = []
          if (this.serviceArr.length > 0 || this.sureArr.length > 0) {
            servicerequirementstag = 1
          }
          this.serviceArr.forEach(item => {
            if (item.key !== '') {
              let obj = {key: item.key, value: '', required: (item.required || item.required === 0) ? item.required : 0}
              arr0.push(obj)
            }
          })
          this.sureArr.forEach(item => {
            if (item.key !== '') {
              let obj = {key: item.key, value: '', required: (item.required || item.required === 0) ? item.required : 0}
              arr1.push(obj)
            }
          })
          servicerequirements[0] = arr0
          servicerequirements[1] = arr1
          let picturerequirementstag = 0
          let picturerequirements = []
          if (this.pictureArr.length > 0) {
            picturerequirementstag = 1
          }
          this.pictureArr.forEach(item => {
            if (item.key !== '') {
              let obj = {key: item.key, value: '', required: (item.required || item.required === 0) ? item.required : 0}
              picturerequirements.push(obj)
            }
          })
          let data = {
            'id': this.addEditForm.id,
            'so_id': this.addEditForm.so_id,
            'st_id': this.addEditForm.st_id,
            'service_name': this.addEditForm.service_name,
            'orgid': this.addEditForm.orgid,
            'time_duration': this.addEditForm.time_duration,
            'price': price + '',
            is_have_type: this.addEditForm.is_have_type,
            up_level: this.addEditForm.up_level,
            up_id: this.addEditForm.up_id,
            service_requirements: JSON.stringify(servicerequirements),
            service_requirements_tag: servicerequirementstag,
            picture_requirements: JSON.stringify(picturerequirements),
            picture_requirements_tag: picturerequirementstag
          }
          if (this.isAdd) {
            if (this.addEditForm.is_service === 1) {
              data.is_have_type = 1
            }
            addsupplierservice(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功新建服务内容',
                type: 'success',
                duration: 2000
              })
              let content = data
              content.add = true
              this.$emit('changeUpadte', content)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '新建服务内容失败'
              })
            })
          } else {
            addsupplierservice(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功修改服务内容',
                type: 'success',
                duration: 2000
              })
              this.$emit('changeUpadte', data)
            }).catch(() => {
              this.$notify.error({
                title: '失败',
                message: '修改服务内容失败'
              })
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.btn-add{
  width: 58px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #3D83F3;
  cursor: pointer;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3D83F3;
}
.table-type{
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
}
.table-type th{
  text-align: left;
  padding-left: 10px;
  box-sizing: border-box;
  height: 30px;
  background: #EBF2FA;
  color: #3D83F3;
  font-size: 14px;
}
.table-type td{
  padding: 5px;
  box-sizing: border-box;
  background: #F3F7FC;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #3D3D3D;
}
.input{
  padding: 5px;
  border-radius: 4px;
  border: 1px solid #b3cbee;
  outline: none;
  height: 30px;
  font-size: 14px;
  background: none;
  box-sizing: border-box;
}
</style>
<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/servicemanagement/childComponents/addEditScontent.vue